import EntityModel from '@/common/models/entity-model';
import timezones from '@/data/timezones';

export default class ProfileModel extends EntityModel {
    hydrate({
        createdTime = null,
        email = null,
        firstName = null,
        id = null,
        lastName = null,
        preferences = null,
        reportingCurrency = null,
        totpSecret = null,
        totpUrl = null,
        totpRequired = null,
        oneTimePassword = null,
        availableCurrencies = null,
    } = {}) {
        this.createdTime = createdTime;
        this.email = email;
        this.firstName = firstName;
        this.id = id;
        this.lastName = lastName;
        this.preferences = Array.isArray(preferences)
            ? {timezone: {ui: timezones.default}} : preferences;
        this.reportingCurrency = reportingCurrency;
        this.totpSecret = totpSecret;
        this.totpUrl = totpUrl;
        this.totpRequired = totpRequired;
        this.oneTimePassword = oneTimePassword;
        this.availableCurrencies = availableCurrencies;
    }

    get timezone() {
        return this.preferences.timezone
            ? this.preferences.timezone.ui
            : timezones.default;
    }

    set timezone(value) {
        this.preferences = {
            ...this.preferences,
            ...{timezone: {ui: value}},
        };
    }
}
